import axios from 'axios';

const login = (request) => {
   const params = {
      endpoint: `${process.env.REACT_APP_CORE_API}/login`,
      method: 'POST',
      body: {
         username: request.user,
         password: request.password
      }
   };

   return call(params);
};

function call({ endpoint, method, body, params, token, language, account, channel, key, acceptHeader }) {

   let config = {
      url: endpoint,
      method: method,
      headers: {}
   }; 
 
   if (body && body !== null) {
      config.data = body;
   }

   if (params && params !== null) {
      config.params = params;
   }

   if (language && typeof language === 'string' && language !== '') {
      config.headers['Accept-Language'] = language;
      // config = addLocale(config, language);
   }

   if (account && typeof account === 'string' && account !== '') {
      config.headers['account'] = account;
   }

   if (channel && typeof channel === 'number' && channel > 0) {
      config.headers['channel'] = channel;
   }
   if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
   }
   if (key){
      config.headers['x-api-key'] = key;
   }
   if(acceptHeader && acceptHeader !== null){
      config.headers['Accept'] = acceptHeader;
   }
   return axios.request(config);
}

export default {
   call,
   login
};
